import React from "react";
import { Col, Row } from "react-bootstrap";

import Apple from "../../assets/images/Home/social media/Apple.png";
import Android from "../../assets/images/Home/social media/Android.png";
import RightApple from "../../assets/images/Home/social media/R - Apple.png";
import RightAndroid from "../../assets/images/Home/social media/R - And.png";

const SocialMedia = () => {
  return (
    <>
      <div className="social-media-component container">
        {/* <Row> */}
        <div className="d-flex justify-content-center w-100">
        <Col className="join-us-detail" xs={12} md={12} s>
            <div className="text">
              <h1>
                Get Started Today!
                <br />
                Download <span>Rolidex</span>
                {/* now and get 50 points! */}
              </h1>
              <p className="mt-2">
                Join thousands of professionals simplifying their networking
                experience. Download now and take control of your business
                connections.
              </p>
            </div>
            <div className="os-type mt-2">
              <img src={Apple} className="apple" alt="" />
              <img src={Android} alt="" />
            </div>
          </Col>
        </div>

          {/* <Col className="types" xs={12} md={{ span: 5, offset: 1 }}>
            <div className="os-type-image d-flex">
              <img src={RightApple} className="apple-img mt-1" alt="" />
              <img src={RightAndroid} className="mt-4" alt="" />
            </div>
          </Col> */}
        {/* </Row> */}
      </div>
    </>
  );
};
export { SocialMedia };
